import React, { useContext } from "react";
import { Row, Col, Layout } from "antd";
import "antd/dist/antd.css"; // or 'antd/dist/antd.less'
import MyHeader from "./MyHeader";
import MyPurpose from "./MyPurpose";
import MyFooter from "./MyFooter";
import MyColumn from "./MyColumn";
import mainContext from "../context/mainContext";
import themeContext from "../context/themeContext";
import MyColumnContent from "./MyColumnContent";
import MyMarquee from "./MyMarquee";
const style = {
  margin: "5px",
};

export default function MyLayout() {
  const ctxtheme = useContext(themeContext);
  const ctxmain = useContext(mainContext);
  return (
    <div>
      <Row>
        <Col span={24}>
          <MyHeader />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <MyPurpose />
        </Col>
      </Row>

      {ctxmain.txtmarquee != "" && (
        <Row style={{ marginTop: "5px" }}>
          <Col span={24}>
            <MyMarquee />
          </Col>
        </Row>
      )}
      <Row>
        <Col className="gutter-row" span={8}>
          <div style={style}>
            <MyColumn title={ctxtheme.state.column1title}>
              <MyColumnContent
                headdata={ctxmain.col1headdata}
                fooddata={ctxmain.col1fooddata}
                pngdata={ctxmain.col1imagedata}
              />
            </MyColumn>
          </div>
        </Col>
        <Col className="gutter-row" span={8}>
          <div style={style}>
            <MyColumn title={ctxtheme.state.column2title}>
              <MyColumnContent
                headdata={ctxmain.col2headdata}
                fooddata={ctxmain.col2fooddata}
                pngdata={ctxmain.col2imagedata}
              />
            </MyColumn>
          </div>
        </Col>
        <Col className="gutter-row" span={8}>
          <div style={style}>
            <MyColumn title={ctxtheme.state.column3title}>
              <MyColumnContent
                headdata={ctxmain.col3headdata}
                fooddata={ctxmain.col3fooddata}
                pngdata={ctxmain.col3imagedata}
              />
            </MyColumn>
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <MyFooter />
        </Col>
      </Row>
    </div>
  );
}
